interface TimerControls {
  resume(): void;
  pause(): void;
  stop(): void;
}

interface TimerOptions {
  timeout: number;
  enabled: boolean;
}

/**
 * Creates a timer with pause, resume, and stop functionality
 * @param callback Function to call when timer completes
 * @param options Timer configuration options
 * @param getTime Function that returns current time in milliseconds (defaults to Date.now)
 * @returns Timer control object
 */
const timer = (callback: Function, options: TimerOptions, getTime: () => number = Date.now): TimerControls => {
  const { timeout, enabled } = options;
  let startedAt: number;
  let timeRemaining: number = timeout;
  let id: number;

  return {
    stop() {
      if (!enabled) return;

      timeRemaining = timeout;
      window.clearTimeout(id);
      id = 0;
    },
    pause() {
      if (!enabled) return;

      timeRemaining -= getTime() - startedAt;
      window.clearTimeout(id);
      id = 0;
    },
    resume() {
      if (!enabled) return;

      startedAt = getTime();
      id = window.setTimeout(callback, Math.max(0, timeRemaining));
    },
  };
};

export default timer;
